import moment from "moment";
import { FormValidationRule } from "../../forms/types";

const isSunday: FormValidationRule = (c, v) => {
    let valid = true;
    let message = "";

    if (c.field_boi_date_not_sunday && v) {
        const value = moment(v, "YYYY-MM-DD");

        if (value.isoWeekday() === 7) {
            valid = false;
            message = "Sundays are not available. Please select another day.";
        }
    }
    return [valid, message];
};

export default isSunday;
